import { FirebaseError } from "firebase/app";
import { ProviderContext } from "notistack";

export interface InputState {
  errorMessage: string | undefined;
  value: string;
}

export function handleError(userErrorText: string, error: unknown, enqueueSnackbar: ProviderContext['enqueueSnackbar'], setIsLoading: React.Dispatch<React.SetStateAction<boolean>>) {
    if (error instanceof FirebaseError) {
      console.error(userErrorText + ": " + error.message);
      enqueueSnackbar(userErrorText + ": " + error.message, {
        variant: "error",
        autoHideDuration: 6000,
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
    } else {
      console.error(userErrorText + ": " + JSON.stringify(error));
    }
    setIsLoading(false);
}